import * as React from 'react';

import {Button} from 'shells/button/button';
// @ts-expect-error
import {UpgradeArrowIcon} from 'shells/icon/svg/upgrade-arrow-icon';
import {IconSection} from 'shells/icon-section/icon-section';
import {Body} from 'shells/typography/body';

import {AiFeatureType} from 'nutshell-graphql-types';

import {AiFeatureGateModal} from '../../../ai-home/ai-feature-gate-modal/ai-feature-gate-modal';

interface Props {
    copy: string;
}

export function TranscriptSummaryFeatureGated(props: Props) {
    const [showFeatureGateModal, setShowFeatureGateModal] = React.useState<boolean>(false);

    return (
        <>
            <div className='flex align-center justify-sb'>
                <Body size='small'>{props.copy}</Body>
                <Button
                    variant='text-primary'
                    onClick={() =>
                        NutClientConfig.hasAiOutcomesFF
                            ? setShowFeatureGateModal(true)
                            : window.open('/setup/billing', '_blank')
                    }
                >
                    <IconSection icon={UpgradeArrowIcon} marginTopValue={0} gap={8}>
                        Upgrade your plan
                    </IconSection>
                </Button>
            </div>
            <AiFeatureGateModal
                isOpen={showFeatureGateModal}
                onClose={() => setShowFeatureGateModal(false)}
                reason='outOfCredits'
                aiFeatureType={AiFeatureType.CLICK_TO_CALL_NOTETAKER}
            />
        </>
    );
}
